export const DistanceFilterOption = ({ distance, ...props }) => {
    return <option id={distance} value={distance === "0km" ? '' :`&distance=${distance.replace("+", "")}`}>
        {distance}
    </option>;
}